var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 49,
    viewBox: "0 0 34 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.704 18.8189C27.6407 15.8194 27.8569 12.824 27.5784 9.83921C26.5806 3.63514 20.989 -0.328031 14.8127 0.775004C10.3353 1.5738 6.62009 5.49139 6.17914 10.0255C5.9637 12.9714 6.10205 15.8354 6.06519 18.8202C3.34647 18.52 0.733656 19.5841 0.820438 22.6627C0.906215 26.6741 0.589913 30.7217 1.03186 34.713C2.41904 43.3898 10.4991 49.3247 19.1877 48.0702C26.8687 46.9604 32.7005 40.4681 32.8945 32.7174C32.3343 27.3389 35.571 17.799 27.704 18.8189ZM18.8701 33.2562C19.0021 34.8257 18.9324 37.1591 16.8825 37.1229C13.7804 36.9326 15.7969 33.6287 14.2522 32.1048C10.7166 27.0735 20.0294 23.7845 20.2884 30.3343C20.3795 31.7242 18.9934 32.247 18.8701 33.2562ZM22.8298 18.7894H10.9277C11.2158 14.3692 9.31535 8.00031 14.4499 5.83042C16.7183 4.81317 18.8861 5.1657 20.7936 6.76597C24.1929 9.71455 22.4995 14.8263 22.8298 18.7894Z",
    fill: "#173567"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.964961cb92dfad9d99f4c37e46e0610d.svg";
export { ForwardRef as ReactComponent };